import { formatNumber } from "../../../helpers/number/numberFormat"
import theme from "../../theme"
import { Box } from '../Box'
import { Icon } from "../Icon"
import { openIndustrialTab } from '../../../helpers/cretool-extjs/Tabs'
import SeeMoreDetailIcon from '../../../assets/icons/icon_see_more_details.svg'

export const IndustrialSimilarBuildingCard = ({ building, index }) => {

    const handleClickImgIndustrial = (industrial) => {
        openIndustrialTab(industrial);
    }

    return (
        <div style={styles.container}>
            <div style={styles.numberContainer}>{index}</div>
            <Box style={styles.contentContainer}>
                <div style={styles.photoContainer}>
                    <img 
                        src={`https://d6bmyxfy7viyd.cloudfront.net/90x115/${building.img_fachada}`} 
                        width={'100%'} 
                    />
                    {/* <Image url={building.img_fachada} width={90} height={115} /> */}
                </div>
                <Box style={styles.buildingNameAddressContainer}>
                    <div style={styles.buildingName} onClick={() => handleClickImgIndustrial(building)}>{building.nome_imovel}</div>
                    <div>{building.endereco}</div>
                    <Box style={{ marginTop: 5 }}>
                        <Box style={styles.statsContainer}>
                            <Icon color={'#000'} icon={'floorPlanIcon'} width={20} />
                            <div style={styles.statsText}>{formatNumber(building.area_locavel_total, 0)}</div>
                        </Box>
                        <Box style={styles.statsContainer}>
                            <Icon color={'#000'} icon={'floorPlanVacancyIcon'} width={20} />
                            <div style={styles.statsText}>{formatNumber(building.area_locavel_disponivel, 0)}</div>
                        </Box>
                        <Box style={styles.statsContainer}>
                            <Icon color={'#000'} icon={'percentualIcon'} width={20} />
                            <div style={styles.statsText}>{formatNumber(building.area_locavel_disponivel / building.area_locavel_total * 100, 2)}</div>
                        </Box>
                    </Box>
                </Box>
                <div style={styles.seeMoreDetails}>
                    <div style={styles.seeMoreDetailsIcon} onClick={() => handleClickImgIndustrial(building)}>
                        <img src={SeeMoreDetailIcon} width={'100%'} height={'100%'} />
                    </div>
                </div>
            </Box>
        </div>
    )
}

const styles = {
    container: {
        backgroundColor: '#D9D9D9',
        marginLeft: 5,
        marginRight: 5,
        position: 'relative'
    },
    numberContainer: {
        backgroundColor: theme.palette.secondary.main,
        position: 'absolute',
        width: 20,
        height: 20,
        color: '#FFF',
        borderRadius: 10,
        top: -6,
        left: -4,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 12
    },
    contentContainer: {
        flexDirection: 'row',
        display: 'flex'
    },
    photoContainer: {
        width: 90,
        height: 115
    },
    buildingNameAddressContainer: {
        flexDirection: 'column', 
        display: 'flex', 
        flex: 1,
        fontSize: 12,
        minWidth: 230,
        cursor: 'pointer',
        padding: 5
    },
    buildingName: {
        cursor: 'pointer',
        fontWeight: '700'
    },
    buildingAddress: {
        color: '#565656'
    },
    statsContainer: {
        flexDirection: 'row',
        display: 'flex'
    },
    statsText: {
        fontSize: 14,
        fontWeight: '700',
        marginLeft: 6
    },
    seeMoreDetails: {
        position: 'absolute',
        bottom: 10,
        right: 10
    },
    seeMoreDetailsIcon: {
        width: 22,
        height: 22,
        cursor: 'pointer'
    }
}